import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { L } from "@/i18n";

const parentOf = (title) => String(title ?? "").split(".")[0];

const bySubmodule = (data) => {
  const groups = (data?.groups ?? []).flatMap((g) => {
    const buckets = {};
    (g.items ?? []).forEach((i) => (buckets[i.module_title ?? ""] ??= []).push(i));
    return Object.entries(buckets)
      .filter(([, items]) => items.length > 1)
      .map(([sub, items]) => ({ hash: `${g.hash}-${sub}`, count: items.length, submodule: sub, parents: [parentOf(sub)], items }));
  });
  const perModule = {};
  groups.forEach((g) => (perModule[g.parents[0]] = (perModule[g.parents[0]] ?? 0) + g.count - 1));
  return {
    total_groups: groups.length,
    total_extras: groups.reduce((n, g) => n + g.count - 1, 0),
    per_module_extras: perModule,
    groups,
  };
};

export const useDuplicates = () =>
  useQuery({
    queryKey: ["duplicates"],
    queryFn: async () => (await api.get("/admin/duplicate-questions")).data,
    select: bySubmodule,
  });

export const useDeleteQuestions = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (ids) => {
      const results = await Promise.allSettled(ids.map((id) => api.delete(`/questions/${id}`)));
      const failed = results.filter((r) => r.status === "rejected");
      return { ok: results.length - failed.length, failed: failed.length, error: failed[0]?.reason };
    },
    onSuccess: ({ ok, failed, error }) => {
      if (ok) toast.success(L("{n} question(s) deleted.", "{n} pergunta(s) eliminada(s).", { n: ok }));
      if (failed) toast.error(L("{n} deletion(s) failed: {e}", "{n} eliminação(ões) falharam: {e}", { n: failed, e: errorMessage(error) }));
      ["duplicates", "distribution", "dashboard", "questions"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
    },
    onError: (e) => toast.error(L("Failed to delete: {e}", "Falha ao eliminar: {e}", { e: errorMessage(e) })),
  });
};
